export default {
      id: "arrow_right-usage",
      viewBox: "0 0 9.346 12.466",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#arrow_right-usage",
      toString: function () {
        return this.url;
      }
    }